
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-resume",
      function () {
        return require("private-next-pages/ai-resume/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-resume"])
      });
    }
  